import { useTranslation } from 'react-i18next';

import { HeaderNotification } from './HeaderNotification';

export const RequestConfigHeaderNotifications = () => {
    const { t } = useTranslation();
    return (
        <div className="flex flex-wrap justify-end gap-2">
            <HeaderNotification
                name="kreditBetrag"
                displayName={t('BANK_CREDIT_REQUEST.FORM_NOTIFICATIONS.KREDITBETRAG')}
            />
            <HeaderNotification
                name="kreditLaufzeit"
                displayName={t('BANK_CREDIT_REQUEST.FORM_NOTIFICATIONS.LAUFZEIT')}
                units="Monate"
            />
            <HeaderNotification
                name="verwendungszweck"
                displayName={t('BANK_CREDIT_REQUEST.FORM_NOTIFICATIONS.VERWENDUNGSZWECK')}
            />
            <HeaderNotification
                name="provision"
                displayName={t('BANK_CREDIT_REQUEST.FORM_NOTIFICATIONS.PROVISION')}
                units="%"
            />
            <HeaderNotification
                name="ratenzahlungstermin"
                displayName={t('BANK_CREDIT_REQUEST.FORM_NOTIFICATIONS.RATENZAHLUNGSTERMIN')}
            />
        </div>
    );
};
